import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from 'react';
import { groupKeysMap } from '../../_util/transKeys';

function useData(dataSource, rowKey, targetKeys) {
  var mergedDataSource = React.useMemo(function () {
    return (dataSource || []).map(function (record) {
      if (rowKey) {
        record = Object.assign(Object.assign({}, record), {
          key: rowKey(record)
        });
      }

      return record;
    });
  }, [dataSource, rowKey]);

  var _React$useMemo = React.useMemo(function () {
    var leftData = [];
    var rightData = new Array((targetKeys || []).length);
    var targetKeysMap = groupKeysMap(targetKeys || []);
    mergedDataSource.forEach(function (record) {
      // rightData should be ordered by targetKeys
      // leftData should be ordered by dataSource
      if (targetKeysMap.has(record.key)) {
        rightData[targetKeysMap.get(record.key)] = record;
      } else {
        leftData.push(record);
      }
    });
    return [leftData, rightData];
  }, [mergedDataSource, targetKeys, rowKey]),
      _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
      leftDataSource = _React$useMemo2[0],
      rightDataSource = _React$useMemo2[1];

  return [mergedDataSource, leftDataSource, rightDataSource];
}

export default useData;